import { render } from "./TestVideoPlayer.vue?vue&type=template&id=5f2dac01"
import script from "./TestVideoPlayer.vue?vue&type=script&lang=js"
export * from "./TestVideoPlayer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__